/*
 * $Id:: model.js 2021/02/02 07:25 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { all, call, put, takeLatest } from 'redux-saga/effects';

import { LITERALS_SLICE_NAME } from '../../app/constants';
import { getLocale, setLocale } from '../../providers';
import { SLICE_NAME } from './constants';
import {
    createAccount,
    queryForgotPassword,
    queryResetPassword,
    queryValidateResetToken,
    requestVerificationCode,
    requestAccountVerification,
    validateEmailAndPassword,
    requestUserInfo,
} from './service';

function* requestForUserinfo(action) {
    yield all([put({ type: `${SLICE_NAME}/loading`, payload: true }), put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(requestUserInfo, action.payload);
    if (response && !response.error) {
        let myStorage = window.sessionStorage;
        let userLang = myStorage.getItem('lang');
        const defaultLanguage = userLang || getLocale();
        const { language } = response;
        if (defaultLanguage !== language && !userLang) {
            let lang = '';
            if (language !== 'pt' && language !== '') {
                setLocale('en');
                lang = 'en';
            } else {
                setLocale(language || 'pt');
                lang = language || 'pt';
            }
            yield put({ type: `${LITERALS_SLICE_NAME}/fetchLiterals`, payload: { language: lang } });
        }
        yield all([
            put({ type: `${SLICE_NAME}/me`, payload: { ...response } }),
            put({ type: `${SLICE_NAME}/error`, payload: null }),
            put({ type: `${SLICE_NAME}/loading`, payload: false }),
        ]);
    }
}

function* getUserInfo() {
    yield takeLatest(`${SLICE_NAME}/getUserinfo`, requestForUserinfo);
}

function* forgotPassword(action) {
    yield put({ type: `${SLICE_NAME}/loading`, payload: true });
    yield put({ type: `${SLICE_NAME}/error`, payload: false });
    const response = yield call(queryForgotPassword, action.payload);
    if (typeof response === 'object' && response.error === undefined) {
        yield put({
            type: `${SLICE_NAME}/resetAccount`,
            payload: response,
        });
    } else {
        yield put({
            type: `${SLICE_NAME}/error`,
            payload: response.error,
        });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* requestForgotPassword() {
    yield takeLatest(`${SLICE_NAME}/forgotPassword`, forgotPassword);
}

function* validateResetToken(action) {
    yield put({ type: `${SLICE_NAME}/loading`, payload: true });
    yield put({ type: `${SLICE_NAME}/error`, payload: false });
    const response = yield call(queryValidateResetToken, action.payload);
    if (typeof response === 'object' && response.error === undefined) {
        yield put({
            type: `${SLICE_NAME}/auth`,
            payload: response,
        });
    } else {
        yield put({
            type: `${SLICE_NAME}/error`,
            payload: response.error,
        });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* requestValidateToken() {
    yield takeLatest(`${SLICE_NAME}/validateResetToken`, validateResetToken);
}

function* resetPassword(action) {
    yield put({ type: `${SLICE_NAME}/loading`, payload: true });
    yield put({ type: `${SLICE_NAME}/error`, payload: false });
    const response = yield call(queryResetPassword, action.payload);
    if (typeof response === 'object' && response.error === undefined) {
        yield put({
            type: `${SLICE_NAME}/resetPasswd`,
            payload: response,
        });
    } else {
        yield put({
            type: `${SLICE_NAME}/error`,
            payload: response.error,
        });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* requestResetPassword() {
    yield takeLatest(`${SLICE_NAME}/resetPassword`, resetPassword);
}

function* validateCreds(action) {
    yield put({ type: `${SLICE_NAME}/loading`, payload: true });
    yield put({ type: `${SLICE_NAME}/error`, payload: false });
    const response = yield call(validateEmailAndPassword, action.payload);
    if (typeof response === 'object' && response.error === undefined) {
        yield put({
            type: `${SLICE_NAME}/registration`,
            payload: response,
        });
    } else {
        yield put({
            type: `${SLICE_NAME}/error`,
            payload: response.error,
        });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* validateCredentials() {
    yield takeLatest(`${SLICE_NAME}/validateCredentials`, validateCreds);
}

function* registerUser(action) {
    yield put({ type: `${SLICE_NAME}/loading`, payload: true });
    yield put({ type: `${SLICE_NAME}/error`, payload: false });
    const response = yield call(createAccount, action.payload);
    if (typeof response === 'object' && response.error === undefined) {
        yield put({
            type: `${SLICE_NAME}/registration`,
            payload: response,
        });
    } else {
        yield put({
            type: `${SLICE_NAME}/error`,
            payload: response.error,
        });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* registerAccount() {
    yield takeLatest(`${SLICE_NAME}/registerAccount`, registerUser);
}

function* requestNewVerificationToken(action) {
    yield all([
        yield put({ type: `${SLICE_NAME}/loading`, payload: true }),
        yield put({ type: `${SLICE_NAME}/error`, payload: false }),
        yield put({ type: `${SLICE_NAME}/registration`, payload: {} }),
    ]);
    const response = yield call(requestVerificationCode, action.payload);
    if (typeof response === 'object' && response.error === undefined) {
        yield put({
            type: `${SLICE_NAME}/registration`,
            payload: response,
        });
    } else {
        yield put({
            type: `${SLICE_NAME}/error`,
            payload: response.error,
        });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* sendNewVerificationCode() {
    yield takeLatest(`${SLICE_NAME}/requestNewVerificationCode`, requestNewVerificationToken);
}

function* validateVerificationCode(action) {
    yield put({ type: `${SLICE_NAME}/loading`, payload: true });
    yield put({ type: `${SLICE_NAME}/error`, payload: false });
    const response = yield call(requestAccountVerification, action.payload);
    if (typeof response === 'object' && response.error === undefined) {
        yield put({
            type: `${SLICE_NAME}/registration`,
            payload: response,
        });
    } else {
        yield put({
            type: `${SLICE_NAME}/error`,
            payload: response.error && response.error.description,
        });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* verifyAccount() {
    yield takeLatest(`${SLICE_NAME}/verifyAccount`, validateVerificationCode);
}

export {
    registerAccount,
    requestForgotPassword,
    requestResetPassword,
    requestValidateToken,
    sendNewVerificationCode,
    validateCredentials,
    verifyAccount,
    getUserInfo,
};
